import type { Direction, DungeonFloor, DungeonRoom } from '../game/types';

const CARDINAL: Direction[] = ['NORTH', 'SOUTH', 'EAST', 'WEST'];

/** Mark adjacent connected rooms as DISCOVERED if still hidden. */
export function discoverAdjacent(floor: DungeonFloor, fromRoomId: string): DungeonFloor {
  const from = floor.rooms[fromRoomId];
  if (!from) {
    return floor;
  }

  const rooms: Record<string, DungeonRoom> = { ...floor.rooms };

  for (const connection of from.connections) {
    if (connection.isLocked) {
      continue;
    }

    const neighbor = rooms[connection.targetRoomId];
    if (!neighbor) {
      continue;
    }

    if (neighbor.status === 'UNEXPLORED') {
      rooms[connection.targetRoomId] = {
        ...neighbor,
        status: 'DISCOVERED',
      };
    }
  }

  return { ...floor, rooms };
}

export function listConnectedDirections(room: DungeonRoom): Direction[] {
  return room.connections
    .filter((c) => !c.isLocked && CARDINAL.includes(c.direction))
    .map((c) => c.direction);
}
